exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon-recoed-container[data-v-4307e9ca]{margin:20px 0 0 20px;background:#fff;padding:10px;min-height:calc(100vh - 120px)}.coupon-recoed .pagination[data-v-4307e9ca]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:10px 0}", ""]);

// exports
